import {Injectable} from '@angular/core';
import {SidenavFilter, SidenavFilterChain, SidenavItem} from '@mctic/ng-core';
import {Observable, of} from 'rxjs';
import {SecurityService} from 'src/app/service';
import {SigplaniModuloEnum} from '../../shared/enum/sigplani-modulo.enum';
import {SidenavItemEnum} from '../sidenav-item.enum';

@Injectable({
  providedIn: 'root'
})
export class FiscalizacaoSidenavFilter implements SidenavFilter {

  readonly mappings: string[] = [
    SidenavItemEnum.FiscalizacaoElaborarParecer
  ];
  readonly skipping: string[] = [
  ];

  constructor(private readonly securityService: SecurityService) {
  }

  canActivate(sidenavItem: SidenavItem): Observable<boolean> {
    return of(this.securityService.isModuloAtivo(SigplaniModuloEnum.FISCALIZACAO));
  }

  doFilter(sidenavItem: SidenavItem, chain: SidenavFilterChain): Observable<boolean> {
    return chain.nextOrComplete(sidenavItem, this.securityService.isModuloAtivo(SigplaniModuloEnum.FISCALIZACAO));
  }

}
